import { components } from "react-select";
import React from "react";

export const CustomControlIconError = (props: any) => {
    const offset = props.selectProps?.errorIconRightOffset ?? "34px";
    const hasValue = typeof props.getValue === "function" && props.getValue().length > 0;
    const floatingLabel: string = props.selectProps?.floatingLabel;

    return (
        <components.Control {...props}>
            {hasValue && floatingLabel && (
              <small className="fs-8 text-grey position-absolute" style={{ top: 2, left: 10, pointerEvents: "none" }}>
                {floatingLabel}
              </small>
            )}
            {props.children}
            {props.selectProps.error && (
                <i
                    className="bi bi-exclamation-circle fs-20 position-absolute top-50 end-0 translate-middle-y text-danger p-1 fw-bold"
                    style={{
                        marginRight: offset,
                        backgroundColor: "inherit",
                    }}
                ></i>
            )}
        </components.Control>
    );
};
